// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609241104/js/" + chunkId + "." + {"44":"41fced1c","225":"801c595c","481":"4fd08494","486":"2a7db766","770":"4c8830ab"}[chunkId] + ".0.010652299836497958.chunk.js";
};